import { render, staticRenderFns } from "./commonSidebar.vue?vue&type=template&id=81d82d56&scoped=true"
import script from "./commonSidebar.vue?vue&type=script&lang=js"
export * from "./commonSidebar.vue?vue&type=script&lang=js"
import style0 from "./commonSidebar.vue?vue&type=style&index=0&id=81d82d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d82d56",
  null
  
)

export default component.exports